import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { GlobalService } from '../services/global.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap'

import { UserService } from '../services/user.service';

@Injectable()
export class AuthService {
  constructor(private http: Http, private userService: UserService, private globalService: GlobalService) { }

  login(username: string, password: string) {
    let body = `username=${username}&password=${password}&grant_type=password`;
    let test = { UserID: '0' };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
    
    let options;

    let user;

    //var authUrl = 'https://authpentest.hvsfinancial.com/Token';
    var authUrl = 'https://auth.hvsfinancial.com/Token';

    //var apiUrl = 'http://api.hvsfinancial.com.loc/api/';
    // var apiUrl = 'https://hvsportalpentestsvc.hvsfinancial.com/api/';
    var apiUrl = 'https://apidev3.hvsfinancial.com/api/';

    return this.http.post(authUrl, body)
      .map((response: Response) => {
        let resp = response.json(), bearer;

        if (resp && resp.access_token) {
          bearer = resp.access_token;

          headers.append('Authorization', `bearer ${bearer}`);
          options = new RequestOptions({headers})

          test.UserID = resp.userID;

          this.userService.setAuthentication(resp);
          // console.log(resp);
          
          return bearer;
        }

        return;
      })
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetUser', JSON.stringify(test), options).map((response: Response) => {
        let resp = response.json();
        user = resp;
        this.userService.setUserInformation(resp);
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrganization', JSON.stringify({ ID: user.OrganizationID}), options).map((response: Response) => {
        let resp = response.json();
        
        localStorage.setItem('logoPhotoPath', resp.LogoPath);
        localStorage.setItem('parentID', resp.ParentID);
        localStorage.setItem('orgID', resp.ID);
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrgFeatures', JSON.stringify({ ID: (localStorage.getItem('parentID') != '0') ? localStorage.getItem('parentID') : localStorage.getItem('orgID')}), options).map((response: Response) => {
        let resp = response.json();
        //if array is empty; allow all
        this.globalService.orgAccess = resp;
        if(resp.length > 0){
          for(let value of resp){

            if(value.FeatureTypeID == 1){
              this.globalService.featRiskTolerance = true;
            }else if(value.FeatureTypeID === 2){
              this.globalService.featHealthCare = true;
            }else if(value.FeatureTypeID == 3){
              this.globalService.featSocialSecurity = true;
            }else if(value.FeatureTypeID == 4){
              this.globalService.featLongTermCare = true;
            }else if(value.FeatureTypeID == 5){
              this.globalService.featTitan = true;
            }else if(value.FeatureTypeID == 6){
              this.globalService.featHomeOffice = true;
            }else if(value.FeatureTypeID == 7){
              this.globalService.featMeansTesting = true;
            }

          }
          
        }else{
          //not in table => lets preset the basic tool/default
          this.globalService.featHealthCare = true;
          this.globalService.featLongTermCare = true;
          this.globalService.featSocialSecurity = true;
          this.globalService.featTitan = true;      
          this.globalService.featMeansTesting = true;     
          
          //these are not part of the basics
          this.globalService.featRiskTolerance = false;
          this.globalService.featHomeOffice = false;     
        }

        this.globalService.hasSetFeatures = true;         

        localStorage.setItem('featRiskTolerance', JSON.stringify(this.globalService.featRiskTolerance || false));
        localStorage.setItem('featHomeOffice', JSON.stringify(this.globalService.featHomeOffice || false));
        localStorage.setItem('featMeansTesting', JSON.stringify(this.globalService.featMeansTesting || false));
        localStorage.setItem('featLongTermCare', JSON.stringify(this.globalService.featLongTermCare || false));
        localStorage.setItem('featSocialSecurity', JSON.stringify(this.globalService.featSocialSecurity || false));
        localStorage.setItem('featHealthCare', JSON.stringify(this.globalService.featHealthCare || false));
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetOrganization', JSON.stringify({ ID: localStorage.getItem('parentID')}), options).map((response: Response) => {
        let resp = response.json();
        
        if (resp && localStorage.getItem('logoPhotoPath') == 'null') {
          localStorage.setItem('logoPhotoPath', resp.LogoPath);
        }
      }))
      .flatMap(() => this.http.post(apiUrl + 'CoreOrganization/GetYearlyValues', '', options).map((response: Response) => {
        let resp = response.json();
        localStorage.setItem('yearlyValues', JSON.stringify(resp));
      }));
  }

  public logout() {
    //localStorage.clear();

    // localStorage.removeItem('bearer');
    // localStorage.removeItem('expiresIn');
    // localStorage.removeItem('firstName');
    // localStorage.removeItem('lastName');
    // localStorage.removeItem('logoPhotoPath');
    // localStorage.removeItem('profilePhotoPath');
    // localStorage.removeItem('roleId');
    // localStorage.removeItem('parentID');
    // localStorage.removeItem('orgID');
    
    localStorage.clear();

    //window.location.href = "portal.hvsfinancial.com";
  }
}
